import Zone from "@insite/client-framework/Components/Zone";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import loadPunchoutIdentityList from "@TKCCP/Store/Data/PunchoutIdentity/Handlers/LoadPunchoutIdentity";
import {
    getIdentityDataView,
    IdentityDataViewContext,
} from "@TKCCP/Store/Data/PunchoutIdentity/PunchoutIdentitySelector";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationStateTKCCP) => ({
    ordersDataView: getIdentityDataView(state, state.pagePunchoutIdentity.getPunchoutParameter),
    getPunchoutParameter: state.pagePunchoutIdentity.getPunchoutParameter,
    // identityView: getIdentityDataView(state),
});

const mapDispatchToProps = {
    loadPunchoutIdentityList,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const PunchoutIdentityPage = ({ id, loadPunchoutIdentityList, getPunchoutParameter, ordersDataView }: Props) => {
    // loadPunchoutIdentityList(undefined);

    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!ordersDataView.value && !ordersDataView.isLoading) {
            loadPunchoutIdentityList(getPunchoutParameter);
        }
    });

    const value = ordersDataView.value;

    return (
        <Page>
            <IdentityDataViewContext.Provider value={ordersDataView}>
                <Zone contentId={id} zoneName="Content" />
                <Modals />
                {/* <PunchoutIdentityModal /> */}
            </IdentityDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PunchoutIdentityPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
export const PunchoutIdentityPageContext = "PunchoutIdentityPage";
